export default "__VITE_ASSET__CqpNyJTY__"